import produce from 'immer'
import Actions from '../actions'
import { routes } from '../consts'
import { isLoggedIn, logOut } from '../utils/fetchUtils'
import { signUpFlowTypes } from '../consts'
import LogRocket from 'logrocket'

const initialState = {
  resetPassword: {
    phone: null,
    token: null,
    newPassword: null,
    loading: false,
    isCodeSentToPhoneSuccess: false,
    isCodeSentToPhoneFailure: false,
    verifyOtpCodeLoading: false,
    verifyOtpCodeErrorMessage: null,
    isPasswordResetLoading: false,
    isPasswordResetSuccess: false,
    isPasswordResetFailure: false,
    passwordResetErrorMessage: null,
  },
  locationVerification: {
    address: null,
    state: null,
    city: null,
    zipcode: null,
  },
  errorMessage: null,
  phoneNumber: null,
  oneTimeLoginError: null,
  isLoggedIn: isLoggedIn(),
  isLoginLoading: false,
  isOneTimeCodeVerificationLoading: false,
  isValidatingIpLoading: false,
  isInvalidIpRecieved: false,
  pathnameToNavigateAfterLoggedIn: '',
  isFromPPFFlow: false,
  signupFlowType: null,
  declareSignUpFlowType: null,
  isThToHmoEnrolled: false,
  isQuickSignupLoading: false,
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.NAVIGATED_TO: {
      draft.errorMessage = null
      break
    }
    // Put a boolean in userDetails to distinguish between loading (null)/loaded no user (false)/loaded waiting for user details (true)
    case Actions.IS_SIGNED_IN_RECEIVED: {
      draft.isLoggedIn = payload.isSignedIn
      break
    }
    case Actions.VALIDATE_STATE_REQUESTED: {
      // NOTE, the payload contains also 'onNext' param so we extract it from payload
      // the '...locationverificationdata' gets all other objects (that we need) and put it inside one object
      const { onNext, ...locationVerificationData } = payload
      draft.locationVerification = locationVerificationData
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      logOut()
      return {
        ...initialState,
        isLoggedIn: false,
        isThToHmoEnrolled: draft.isThToHmoEnrolled,
      }
    }
    case Actions.OTP_CODE_REQUESTED: {
      const { phone } = payload
      draft.resetPassword = {
        ...draft.resetPassword,
        phone: phone,
        loading: true,
        isCodeSentToPhoneSuccess: false,
        isCodeSentToPhoneFailure: false,
        verifyOtpCodeErrorMessage: null,
      }
      draft.errorMessage = null
      break
    }
    case Actions.OTP_CODE_RECIEVED: {
      draft.resetPassword = {
        ...draft.resetPassword,
        loading: false,
        isCodeSentToPhoneSuccess: true,
        isCodeSentToPhoneFailure: false,
        verifyOtpCodeErrorMessage: null,
      }
      break
    }
    case Actions.OTP_CODE_VERIFY_REQUEST_FAILURE: {
      const { error } = payload
      draft.resetPassword = {
        ...draft.resetPassword,
        loading: false,
        isCodeSentToPhoneSuccess: false,
        isCodeSentToPhoneFailure: false,
        verifyOtpCodeLoading: false,
        verifyOtpCodeErrorMessage: error.body.detail,
      }
      draft.errorMessage = null
      break
    }
    case Actions.OTP_CODE_VERIFY_RECEIVED: {
      const { token } = payload
      draft.resetPassword = {
        ...draft.resetPassword,
        loading: false,
        isCodeSentToPhoneSuccess: true,
        isCodeSentToPhoneFailure: false,
        token,
        verifyOtpCodeErrorMessage: null,
        verifyOtpCodeLoading: false,
      }
      draft.errorMessage = null
      break
    }
    case Actions.OTP_CODE_VERIFY_REQUESTED: {
      draft.resetPassword = {
        ...draft.resetPassword,
        loading: false,
        isCodeSentToPhoneSuccess: false,
        isCodeSentToPhoneFailure: false,
        verifyOtpCodeErrorMessage: null,
        verifyOtpCodeLoading: true,
      }
      draft.errorMessage = null
      break
    }

    case Actions.RESET_PASSWORD_REQUESTED: {
      draft.resetPassword = {
        ...draft.resetPassword,
        isPasswordResetLoading: true,
        isPasswordResetSuccess: false,
        isPasswordResetFailure: false,
        passwordResetErrorMessage: null,
        verifyOtpCodeErrorMessage: null,
      }
      break
    }
    case Actions.RESET_PASSWORD_SUCCESS: {
      draft.resetPassword = {
        ...draft.resetPassword,
        isPasswordResetLoading: false,
        isPasswordResetSuccess: true,
        isPasswordResetFailure: false,
        passwordResetErrorMessage: null,
        verifyOtpCodeErrorMessage: null,
      }
      break
    }

    case Actions.RESET_PASSWORD_FAILURE: {
      const { error } = payload
      let errorMessage = ''
      if (error.body?.password && error.body.password.length) {
        errorMessage = error.body.password
      } else {
        errorMessage = error?.body?.message
      }

      draft.resetPassword = {
        ...draft.resetPassword,
        isPasswordResetLoading: false,
        isPasswordResetSuccess: false,
        isPasswordResetFailure: true,
        passwordResetErrorMessage: errorMessage,
        verifyOtpCodeErrorMessage: null,
      }
      break
    }
    case Actions.SIGNIN_REQUESTED: {
      draft.isLoginLoading = true
      draft.errorMessage = null
      break
    }
    case Actions.SIGNIN_RECEIVED: {
      draft.resetPassword = {
        ...draft.resetPassword,
        loading: false,
        verifyOtpCodeErrorMessage: null,
      }
      draft.errorMessage = null
      draft.isLoginLoading = false
      draft.isOneTimeCodeVerificationLoading = false
      break
    }
    case Actions.OPERATION_FAILED: {
      const { error } = payload
      draft.isLoginLoading = false
      draft.oneTimeLoginError = error?.body?.message
      draft.resetPassword = {
        ...draft.resetPassword,
        loading: false,
        isCodeSentToPhoneSuccess: false,
        isCodeSentToPhoneFailure: true,
      }
      draft.errorMessage = error?.message
      draft.isOneTimeCodeVerificationLoading = false

      break
    }
    case Actions.LOGIN_PHONE_NUMBER_REQUESTED: {
      draft.isLoginLoading = true
      draft.oneTimeLoginError = null
      break
    }
    case Actions.LOGIN_PHONE_NUMBER_RECEIVED: {
      const { phone_number } = payload
      draft.phoneNumber = phone_number
      draft.isLoginLoading = false
      draft.oneTimeLoginError = null
      break
    }
    case Actions.ONE_TIME_SMS_LOGIN_CODE_VERIFY_REQUESTED: {
      draft.isOneTimeCodeVerificationLoading = true
      draft.oneTimeLoginError = null
      break
    }

    case Actions.IS_IP_CHANGED_ON_RELOAD: {
      draft.isValidatingIpLoading = true
      draft.isInvalidIpRecieved = false
      break
    }
    case Actions.INVALID_IP_RECIEVED: {
      draft.isValidatingIpLoading = false
      draft.isInvalidIpRecieved = true
      break
    }
    case Actions.VALIDATE_COUNTRY_RECEIVED: {
      draft.isValidatingIpLoading = false
      draft.isInvalidIpRecieved = false
      break
    }

    case Actions.SAVE_LOCATION_TO_NAVIGATE_AFTER_LOGGED_IN: {
      const { pathname } = payload
      draft.pathnameToNavigateAfterLoggedIn =
        pathname.includes(routes.SIGN_IN) ||
        pathname.includes(routes.PAYMENT_PLANS) ||
        pathname.includes(routes.PAYMENT_PLAN_FORM) ||
        pathname.includes(routes.PAYMENT_SUCCESS)
          ? ''
          : pathname
      break
    }

    case Actions.SIGNIN_REQUESTED_FROM_PPF_FLOW: {
      draft.isFromPPFFlow = true
      draft.isLoggedIn = true
      break
    }

    case Actions.CLOSE_EXISTING_PPF_USER_DIALOG: {
      draft.isFromPPFFlow = false
      break
    }
    case Actions.PPF_USER_LOGIN: {
      draft.isLoggedIn = isLoggedIn()
      break
    }
    case Actions.IS_COUPON_SKIP_CHECKOUT_ADDRESS_UPDATE_REQUESTED: {
      draft.locationVerification = payload
      break
    }
    case Actions.TELEHEALTH_SIGNUP_FLOW: {
      draft.signupFlowType = signUpFlowTypes.TELEHEALTH
      LogRocket.track('TELEHEALTH_SIGNUP_FLOW')
      break
    }
    case Actions.QUICK_SIGNUP_REQUESTED: {
      draft.isQuickSignupLoading = true
      break
    }
    case Actions.QUICK_SIGNUP_RECEIVED: {
      draft.isQuickSignupLoading = false
      draft.signupFlowType = signUpFlowTypes.HMO
      LogRocket.track('QUICK_SIGNUP_RECEIVED')
      break
    }
    case Actions.SHOW_SIGNUP_ERROR_POPUP: {
      draft.isQuickSignupLoading = false
      break
    }
    case Actions.HMO_FIRST_LOGIN_FLOW: {
      draft.signupFlowType = signUpFlowTypes.HMO
      LogRocket.track('HMO_FIRST_LOGIN_FLOW')
      break
    }
    case Actions.TH_TO_HMO_ENROLLED_SIGNUP_REQUESTED: {
      draft.isThToHmoEnrolled = true
      break
    }
    case Actions.DECLARE_SIGNUP_FLOW_TYPE: {
      draft.declareSignUpFlowType = payload
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
